import React from "react";
import { Navigate } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const token = localStorage.getItem("token");
  
  // Agar token mil gaya, toh login page dikhao hi mat, seedha dashboard bhej do
  if (token && token !== "undefined" && token !== "null") {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default AuthWrapper;